import FatalError from "@/lib/components/error/FatalError";

export const createError = (message, options) => {
  return new FatalError(message, options);
};
